import { render, staticRenderFns } from "./VideoVue.vue?vue&type=template&id=163828b4&scoped=true"
import script from "./VideoVue.vue?vue&type=script&lang=js"
export * from "./VideoVue.vue?vue&type=script&lang=js"
import style0 from "./VideoVue.vue?vue&type=style&index=0&id=163828b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163828b4",
  null
  
)

export default component.exports